"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.ModalHeader = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var Heading_1 = require("../Heading");
var HFlow_1 = require("../HFlow");
var VFlow_1 = require("../VFlow");
var ModalCloseButton_1 = require("./ModalCloseButton");
var ModalHeaderIcon_1 = require("./ModalHeaderIcon");
exports.ModalHeader = function (props) {
    var title = props.title, subtitle = props.subtitle, header = props.header, _a = props.showCloseIcon, showCloseIcon = _a === void 0 ? true : _a, onCloseButtonClick = props.onCloseButtonClick;
    var _b = header !== null && header !== void 0 ? header : {}, icon = _b.icon, background = _b.background, _c = _b.showBottomBorder, showBottomBorder = _c === void 0 ? true : _c;
    var classes = styles_1.useStyles(exports.createStyles, background, showBottomBorder).classes;
    return (react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 1, justifyContent: 'space-between', alignItems: 'flex-start', style: classes.header, "data-testid": 'modal-header' },
        react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 1.25, justifyContent: 'flex-start', alignItems: subtitle ? 'flex-start' : 'center', "data-testid": 'modal-header-title-area' },
            icon && react_1.default.createElement(ModalHeaderIcon_1.ModalHeaderIcon, { icon: icon }),
            react_1.default.createElement(VFlow_1.VFlow, { vSpacing: 0 },
                react_1.default.createElement(Heading_1.Heading, { level: 1, color: 'normal', fontWeight: 'bold' }, title),
                subtitle && (react_1.default.createElement(Heading_1.Heading, { level: 5, color: 'normal', fontWeight: 'normal' }, subtitle)))),
        showCloseIcon && react_1.default.createElement(ModalCloseButton_1.ModalCloseButton, { onClick: onCloseButtonClick })));
};
exports.createStyles = function (theme, background, showBottomBorder) { return ({
    header: __assign({ position: 'relative', zIndex: 1, width: '100%', height: 'fit-content', padding: '1.5rem 1rem 1rem 2rem', backgroundColor: background ? background : theme.pallete.surface.main }, (showBottomBorder && {
        boxShadow: "0 1px 5px 0 " + theme.pallete.divider + ", 0 2px 1px -1px " + theme.pallete.divider,
    })),
}); };
//# sourceMappingURL=ModalHeader.js.map